import { TimeZone } from '../../lib/types/models/timezones/timezone.types'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function getTimezones() {
  return restApiClient.url(constructApiUrl(API.timezones.getAll.url, null)).get<TimeZone[]>()
}

export function getTripStepTimezones() {
  return restApiClient.url(constructApiUrl(API.timezones.getTripSteps.url, null)).get<TimeZone[]>()
}
